var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditorAddItemIc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 9.5,
    stroke: "#98BDBD",
    strokeDasharray: "2 2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#editor_add_item_ic_svg__clip0_982_5410)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#editor_add_item_ic_svg__clip1_982_5410)",
    stroke: "#98BDBD",
    strokeWidth: 1.667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.333 20a8.333 8.333 0 10-16.666 0 8.333 8.333 0 0016.666 0zM16.667 20h6.666M20 23.333v-6.666"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "editor_add_item_ic_svg__clip0_982_5410"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(10 10)",
    d: "M0 0h20v20H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "editor_add_item_ic_svg__clip1_982_5410"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(-90 20 10)",
    d: "M0 0h20v20H0z"
  })))));
}
export default SvgEditorAddItemIc;